/*
  Behavior for the service page sections (sections/service-*.liquid).
  FAQ accordion, testimonial rotation and fade-in on scroll.
  Moved out of the old service page templates. Each section renders this
  file, so the guard below keeps it from running more than once.
*/
(function () {
    if (window.hiproServicePageLoaded) return;
    window.hiproServicePageLoaded = true;

    function init() {
        // FAQ Accordion
        const faqItems = document.querySelectorAll('.faq-item');

        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');

            question.addEventListener('click', () => {
                faqItems.forEach(otherItem => {
                    if (otherItem !== item && otherItem.classList.contains('active')) {
                        otherItem.classList.remove('active');
                    }
                });
                item.classList.toggle('active');
            });
        });

        // Testimonial Slider
        const dots = document.querySelectorAll('.dot');
        const testimonials = document.querySelectorAll('.testimonial');
        let currentTestimonial = 0;

        function showTestimonial(index) {
            testimonials.forEach(t => { t.style.display = 'none'; });
            dots.forEach(d => { d.classList.remove('active'); });
            testimonials[index].style.display = 'block';
            if (dots[index]) dots[index].classList.add('active');
        }

        if (testimonials.length) {
            showTestimonial(currentTestimonial);

            dots.forEach((dot, index) => {
                dot.addEventListener('click', () => {
                    showTestimonial(index);
                    currentTestimonial = index;
                });
            });

            setInterval(() => {
                currentTestimonial = (currentTestimonial + 1) % testimonials.length;
                showTestimonial(currentTestimonial);
            }, 5000);
        }

        // Animate on scroll
        const animateOnScroll = () => {
            const elements = document.querySelectorAll('.benefit-card, .feature-card, .process-step, .testimonial-content, .pas-image, .pas-text, .contact-card');

            elements.forEach(element => {
                const elementPosition = element.getBoundingClientRect().top;
                const screenPosition = window.innerHeight / 1.3;

                if (elementPosition < screenPosition) {
                    element.style.opacity = '1';
                    element.style.transform = element.classList.contains('pas-text') ? 'translateX(0)' :
                        element.classList.contains('pas-image') ? 'translateX(0)' : 'translateY(0)';
                }
            });
        };

        const elementsToAnimate = document.querySelectorAll('.benefit-card, .feature-card, .process-step, .testimonial-content');
        elementsToAnimate.forEach(element => {
            element.style.opacity = '0';
            element.style.transform = 'translateY(20px)';
            element.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        });

        const pasText = document.querySelector('.pas-text');
        const pasImage = document.querySelector('.pas-image');

        if (pasText && pasImage) {
            pasText.style.opacity = '0';
            pasText.style.transform = 'translateX(-50px)';
            pasText.style.transition = 'opacity 0.7s ease, transform 0.7s ease';

            pasImage.style.opacity = '0';
            pasImage.style.transform = 'translateX(50px)';
            pasImage.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
        }

        const contactCard = document.querySelector('.contact-card');
        if (contactCard) {
            contactCard.style.opacity = '0';
            contactCard.style.transform = 'translateY(30px)';
            contactCard.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
        }

        window.addEventListener('scroll', animateOnScroll);
        animateOnScroll();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
